import React, { useState, useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Box, Tooltip } from "@mui/material";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import router from "./routes";
import InstallPWA from "./components/installPWA";
import "./App.css";

const GOOGLE_CLIENT_ID =
  "27517055621-at6hs53jv88341421v1sg1iijqusqqek.apps.googleusercontent.com";


const App = () => {
  const [adminId, setAdminId] = useState(localStorage.getItem("adminId"));
  const [userId, setUserId] = useState(localStorage.getItem("userId"));

  useEffect(() => {
    const handleStorageChange = () => {
      setAdminId(localStorage.getItem("adminId"));
      setUserId(localStorage.getItem("userId"));
    };
    window.addEventListener("storage", handleStorageChange);
    const interval = setInterval(handleStorageChange, 1000);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  const handleAdminSwitch = () => {
    // Restore the admin's own session token that was stashed when
    // "Login as this user" swapped it out for the impersonated user's token.
    const adminToken = localStorage.getItem("adminToken");
    if (adminToken) {
      localStorage.setItem("token", adminToken);
      localStorage.removeItem("adminToken");
    }
    localStorage.removeItem("userId");
    window.location.href = "/admin/all-leads";
  };

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <RouterProvider router={router} />

      <Box sx={{ display: { xs: "block", md: "none" } }}>
        <InstallPWA />
      </Box>

      {adminId && userId && (
        <Tooltip title="Switch to Admin" placement="left">
          <Box
            onClick={handleAdminSwitch}
            sx={{
              position: "fixed",
              top: "45%",
              right: "0%",
              zIndex: 1000,
              bgcolor: "red",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "5px",
              borderRadius: "30px 0 0 30px",
              cursor: "pointer",
            }}
          >
            <AdminPanelSettingsIcon
              fontSize="medium"
              sx={{
                color: "white",
              }}
            />
          </Box>
        </Tooltip>
      )}
    </GoogleOAuthProvider>
  );
};

export default App;
